import Container from 'react-bootstrap/Container';

function SiteFooter() {
    return (
        <footer className="py-5 my-5">
            <Container className="px-4">
                <p className="text-end">All rights reserved. Construire SA &copy; 2024</p>
            </Container>
        </footer>
    )
}

export default SiteFooter;